<div
  class="loading"
  data-testid="loading"
>
  {{ 'components.loading.loading' | transloco }}...
</div>
